<template>
	<div class="AccountSettingNavBar">
		<el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false">
			<div class="AccountSettingNavBar__links">
				<div class="AccountSettingNavBar-desk">
					<ul>
						<li :class="{ active_link: showUserInformationScreen }">
							User Information
						</li>
						<li :class="{ active_link: showAccountTypescreen }">
							Account Type
						</li>
						<li :class="{ active_link: showFinishSetupScreen }">
							Finish Set Up
						</li>
					</ul>
				</div>
			</div>

			<div class="AccountSettingNavBar__links">
				<div class="AccountSettingNavBar-mobile">
					<ul>
						<li
							v-if="showUserInformationScreen"
							:class="{ active_link: showUserInformationScreen }"
						>
							User Information
						</li>
						<li
							v-if="showAccountTypescreen"
							:class="{ active_link: showAccountTypescreen }"
						>
							Account Type
						</li>
						<li
							v-if="showFinishSetupScreen"
							:class="{ active_link: showFinishSetupScreen }"
						>
							Finish Set Up
						</li>
					</ul>
				</div>
			</div>
			<UserInformation v-if="showUserInformationScreen" />
			<AccountType v-if="showAccountTypescreen" />
			<FinishSetUp v-if="showFinishSetupScreen" />
		</el-dialog>
	</div>
</template>

<script>
import { serverAddr, EventBus } from "../networkConfig";
import UserInformation from "../views/userInformation/UserInformation";
import AccountType from "../views/accountType/AccountType";
import FinishSetUp from "../views/finishSetUp/FinishSetUp";
export default {
	name: "AccountSettingNavBar",
	components: { UserInformation, AccountType, FinishSetUp },
	mixins: [],
	props: [],
	data() {
		return {
			dialogVisible: true,
			isActive: false,
			clicked_link: ""
		};
	},
	computed: {
		showUserInformationScreen() {
			return this.$store.state.user_information_tab;
		},
		showAccountTypescreen() {
			return this.$store.state.acount_type_tab;
		},
		showFinishSetupScreen() {
			return this.$store.state.finish_setup_tab;
		}
	},
	created() {
		this.clicked_link = this.$router.currentRoute.path;
	},
	methods: {
		// redirectToPage: function(pageName) {
		// 		if (pageName == "user-information") {
		// 			this.$store.commit("showUserInformation", true);
		// 			this.$store.commit("showAccountType", false);
		// 			this.$store.commit("showFinishSetup", false);
		// 		}
		// 		if (pageName == "account-type") {
		// 			EventBus.$emit("openAccountType");
		// 		}
		// 		if (pageName == "finish-setup") {
		// 			EventBus.$emit("openFinishSetup");
		// 		}
		// }
	}
};
</script>

<style lang="scss" scoped>
@import "../assets/css/variable.scss";
.AccountSettingNavBar .AccountSettingNavBar__links {
	margin: 0 auto;
}
.AccountSettingNavBar .AccountSettingNavBar__links ul {
	// align-items: center;
	// border: 1px solid #C8C8C8;
	// padding-left: 0;
	// text-align: center;
	list-style-type: none;
	margin: 0;
	padding: 0;
	overflow: hidden;
	background-color: #e8e8e8;
	text-align: center;
}
.AccountSettingNavBar .AccountSettingNavBar__links ul li {
	color: #000;
	display: inline-block;
	font-size: $font-size-lg;
	padding: 10px 48px;
	text-align: center;
	text-decoration: none;
}
.AccountSettingNavBar .AccountSettingNavBar__links .active_link {
	background-color: $orange-bg-button-color;
	color: #fff;
	font-size: $font-size-lg;
	// display: block;
	// font-weight: bold;
}
// .AccountSettingNavBar .AccountSettingNavBar__links .active_link {
// 	background-color: $orange-bg-button-color;
// 	color: #fff;
// 	font-size: $font-size-lg;
// 	// display: block;
// 	// font-weight: bold;
// }
</style>
<style>
.AccountSettingNavBar .el-icon-close {
	display: none;
}
.AccountSettingNavBar .el-dialog {
	width: max-content;
	margin-top: 0 !important;
}
.AccountSettingNavBar .AccountSettingNavBar-mobile {
	display: none !important;
}
@media screen and (max-width: 650px) {
	.AccountSettingNavBar .AccountSettingNavBar__links ul li {
		display: block !important;
	}
	.AccountSettingNavBar .el-dialog {
		width: 90%;
	}
	.AccountSettingNavBar .AccountSettingNavBar__links ul {
		padding: 0px !important;
	}
	.AccountSettingNavBar .AccountSettingNavBar-desk {
		display: none;
	}
	.AccountSettingNavBar .AccountSettingNavBar-mobile {
		display: block !important;
	}
}

@media screen and (max-width: 400px) {
	.AccountSettingNavBar .el-dialog {
		width: 100%;
	}
}

.AccountSettingNavBar .el-dialog__body {
	padding: 0 0 30px 0;
}
.AccountSettingNavBar .el-dialog__header {
	@apply p-0;
}
.AccountSettingNavBar .el-button--primary {
	background-color: #f6b079;
	padding: 13px 12px 11px;
	border-radius: 2px;
	font-size: 15px;
	cursor: pointer;
	letter-spacing: 0.02em;
	transition: all 0.2s ease;
	color: #fff;
	border: none;
}
</style>
